export default __webpack_public_path__ + "static/media/copy.b139afe4.svg";